// Project 2 - CarSales
export const project2 = {
    id: 2,
    title: "CarSales Platform",
    description: "CarSales: We offer a better way to buy and sell vehicles, built around a simple user experience: Intuitive Car catalog: Find your perfect car fast with advanced search and filtering. Detailed listings: Get all the vehicle information you need, plus customer testimonials. Powerful admin dashboard: Easily manage all listings, inventory, and user activity. Modern & efficient: A seamless experience for both buyers and sellers.",
    website: null, // Add website URL if available
    images: [
        "/Project-CarSales/CarSales-Search.png",
        "/Project-CarSales/CarSales-Experience.png",
        "/Project-CarSales/CarSales-Catalog.png",
        "/Project-CarSales/CarSales-Testimonials.png",
        "/Project-CarSales/CarSales-Admin.png",
    ],
};

